var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m19.06 10-6.81-6.81v6.06H1v1.5h11.25v6.06zm-5.31 3.19V6.81L16.94 10z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuMDYwNSAxMC4wMDAxTDEyLjI1IDMuMTg5MkwxMi4yNDk5IDkuMjQ5N0wwLjk5OTk4NSA5LjI0OTdWMTAuNzQ5N0wxMi4yNDk5IDEwLjc0OTdMMTIuMjQ5OSAxNi44MTA1TDE5LjA2MDUgMTAuMDAwMVpNMTMuNzQ5OSAxMy4xODkzTDEzLjc1IDYuODEwNkwxNi45MzkyIDEwTDEzLjc0OTkgMTMuMTg5M1oiLz4KPC9zdmc+Cg==";